/**
 * Builds an HTML srcset string for Contentful images.
 *
 * Each entry appends Contentful Images API query params for webp format and width
 * (`?fm=webp&w=`), then adds the width descriptor (e.g. `640w`).
 */
export const buildContentfulSrcSet = (
  url: string,
  widths: number[],
  useWebp = true
): string =>
  widths.map((w) => `${url}?${useWebp && 'fm=webp&'}w=${w} ${w}w`).join(', ')
